import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { Subscription } from 'rxjs';
import { User } from '../../models/user.model';
import { MeService } from '../../services/me.service';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { Router, RouterModule } from '@angular/router';
import { UserProfile } from '../../models/user-profile.model';
@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.scss',
  standalone: true,
  imports: [MatButtonModule, MatCardModule, RouterModule],
})
export class HomePageComponent implements OnInit, OnDestroy {
  users: User[] = [];
  myUser: UserProfile | undefined;

  usersSubScription?: Subscription;

  constructor(private userService: UserService, private meService: MeService) {}

  ngOnInit(): void {
    this.meService.getMyUserProfile().subscribe({
      next: (response) => {
        this.myUser = response;
      },
      error: () => {},
    });
    this.usersSubScription = this.userService.getAll().subscribe((users) => {
      this.users = users;
    });
  }

  ngOnDestroy(): void {
    if (this.usersSubScription) {
      this.usersSubScription.unsubscribe;
    }
  }
}
